import React from "react";
import BottomNotification from "./BottomNotification";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const BottomDefaultNotification = (props) => {
  const {name, children, className = "", style} = props;

  return <>
    <BottomNotification
      name={name}
      className={`
        flex
        gap-10
        align-items-center
        justify-content-center
        background-color-white
        padding-15
        font-weight-600
        small
        soft-revert-shadow
        ${className}
        `}
      style={{
        border: "2px solid #F65B2D",
        borderRadius: `${theme.borderRadius.xl} ${theme.borderRadius.xl} 0 0`,
        ...style
      }}
    >
      {children}
    </BottomNotification>
  </>;
};

export default BottomDefaultNotification;
